// extracted by mini-css-extract-plugin
module.exports = {"gridItemHero":"GridItemHero--gridItemHero--3lJNT","inner":"GridItemHero--inner--3RA2s","heading":"GridItemHero--heading--3cfYO","description":"GridItemHero--description--5yPWl"};